var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-bg-white tw-opacity-90 tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }